import type { ViewType } from "@/components/calendars/types.ts";
import {
  addDays,
  endOfDay,
  endOfMonth,
  endOfWeek,
  startOfDay,
  startOfMonth,
  startOfWeek,
} from "date-fns";

/**
 * Calculate the date range for a given view type and date.
 * For month view, extends to include visible days from adjacent months.
 * `dayCount` applies to "day" and "multi-day" views — callers pass 2 for the
 * mobile 2-day grid (`multi-day`) and 1 for the single-day variant.
 *
 * Kept dependency-free (only `date-fns`) so it can be imported by low-level
 * stores like `useSharedCalendarState` without pulling in the calendar hooks'
 * heavier module graph.
 */
export const getDateRange = (date: Date, viewType: ViewType, dayCount = 1) => {
  switch (viewType) {
    case "day":
    case "multi-day":
      return { start: startOfDay(date), end: endOfDay(addDays(date, dayCount - 1)) };
    case "week":
      return { start: startOfWeek(date), end: endOfWeek(date) };
    case "month":
      // Month view shows full weeks, so extend to cover visible adjacent month days
      return {
        start: startOfWeek(startOfMonth(date)),
        end: endOfWeek(endOfMonth(date)),
      };
  }
};
